import React from "react"
import { StaticBackdropWithTabsProps } from "../types/modal"
import { Tab, Tabs } from "react-bootstrap"

export const StaticBackdropWithTabs = (props: StaticBackdropWithTabsProps) => {

    return (
        <>
            <Tabs
                activeKey={props.activeTab}
                onSelect={props.onChangeCallback}>
                {props.tabs.map(tab => <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}/>)}
            </Tabs>
            <div className="row ui-has-modules pt-0">
                <div className="col-12 ui-module">
                    <div className="row pb-2 pl-3 pr-3">
                        <div className="col-12 list-group mb-1">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/common/modal/StaticBackdropWithTabs.tsx